import { render, staticRenderFns } from "./a-price.vue?vue&type=template&id=6718589f&lang=pug"
import script from "./a-price.vue?vue&type=script&lang=js"
export * from "./a-price.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports